module.exports = __webpack_public_path__ + "img/ackee_blue.379f6e09.svg";